import { Box } from '@mui/material'
import { SchedulerTabsProps } from './Scheduler.types'
import {
  useScheduleProductionRequirements,
  useSchedulerTableHandlers,
} from './Scheduler.data'
import { SchedulerProductCleanChangeoverTable } from './SchedulerProductCleanChangeover.muiTable'
import { ManagedSourceBanner } from './ManagedSourceBanner'
import { SECTIONS } from './SchedulerInput.sections'

export const ScheduleProductCleanChangeover = ({
  schedulerId,
  iteration,
  readOnly = false,
  onOpenRule,
}: SchedulerTabsProps & {
  readOnly?: boolean
  onOpenRule?: (tab: string) => void
}) => {
  const API = 'product-clean-changeover'
  const { data: responseData = { data: [], predicate: undefined }, isLoading } =
    useScheduleProductionRequirements(schedulerId, API, iteration)
  const { data = [], predicate } = responseData

  const {
    updateTableData,
    uploadScheduleData,
    deleteTableData,
    isSaving,
    isUploading,
    isDeleting,
    updateRowsStatus,
  } = useSchedulerTableHandlers(schedulerId, API, iteration)

  return (
    <Box sx={{ height: 'calc(100vh - 240px)', minHeight: 400 }}>
      {readOnly && onOpenRule && (
        <ManagedSourceBanner
          label="Changeovers"
          onOpen={() => onOpenRule(SECTIONS.RULES_CHANGEOVERS)}
        />
      )}
      <SchedulerProductCleanChangeoverTable
        data={data}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadScheduleData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        updateRowsStatus={updateRowsStatus}
        predicate={predicate}
        deleteTableData={deleteTableData}
        isDeleting={isDeleting}
        readOnly={readOnly}
      />
    </Box>
  )
}
